export default __webpack_public_path__ + "static/media/7d5da5b56d2a9a132881c8c72e0afce4.33045d38.svg";